import AccountCardAddToCartSuccess from './AccountCardAddToCartSuccess';
import withModal from '../../../../../../components/global/modal/withModal';

export const ACCOUNT_CARD_ADD_TO_CART_SUCCESS =
  'modal/ACCOUNT_CARD_ADD_TO_CART_SUCCESS';

export default withModal(AccountCardAddToCartSuccess, {
  name: ACCOUNT_CARD_ADD_TO_CART_SUCCESS,
  hideHeader: true,
  size: 'xs',
});
